// This file was auto-generated by Fern from our API Definition.
export var SimpleEvaluatorDataOutput;
(function (SimpleEvaluatorDataOutput) {
    SimpleEvaluatorDataOutput.Runtime = {
        Python: "python",
        Typescript: "typescript",
        Javascript: "javascript",
    };
})(SimpleEvaluatorDataOutput || (SimpleEvaluatorDataOutput = {}));
